/**
 * Nhan dien iPad de tat css `zoom` cho dropdown cua date picker.
 * WebKit tinh vi tri popup theo kich thuoc chua zoom nen panel bi lech tren iPad.
 * iPadOS 13+ bao UA la "Macintosh" nen phai kiem tra them so diem cham.
 */
export const isIPadDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const isIPadUA = /iPad/i.test(ua);
  const isIPadOSDesktopUA = /Macintosh/i.test(ua) && (navigator.maxTouchPoints || 0) > 1;
  return isIPadUA || isIPadOSDesktopUA;
};

/** Gan class `is-ipad` len the <html> de css co the tat zoom. */
export const applyIPadPlatformClass = (): void => {
  if (typeof document === 'undefined') return;
  if (isIPadDevice()) document.documentElement.classList.add('is-ipad');
};
